import { CheckboxInput, useMassUpdateServiceRequired, useShowContextRequired } from 'ui-builder';
import React from 'react';

export function SelectForMassUpdateCheckbox() {
  const massUpdateService = useMassUpdateServiceRequired();
  const showContext = useShowContextRequired();

  const data = showContext.data;

  if (massUpdateService.isEnabled()) {
    return (
      <CheckboxInput
        source="isChecked"
        label=""
        value={massUpdateService.isChecked(data.id)}
        onChangeCallback={() => {
          massUpdateService.toggleChecked(data.id);
        }}
      />
    );
  } else {
    return null;
  }
}
